import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  MenuList,
  MaterialIcon,
  MenuListItem,
  HOCs,
} from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import BaseMoreButton from 'components/MoreButton';
import { ActionTypes } from 'constants/enums';

import {
  Menu,
  MenuListItemText,
} from './styles';
import messages from './messages';

const { enhanceWithPopper } = HOCs;
const MoreButtonWithPopper = enhanceWithPopper(BaseMoreButton);

class PluginsListItemActions extends Component {
  static getDerivedStateFromProps(props) {
    const list = PluginsListItemActions.getList(props);

    return {
      list,
    };
  }

  static getList({ plugin, currentUser }) {
    const actionsList = [];

    if ((plugin.creator && plugin.creator.accountId) === (currentUser && currentUser.accountId)) {
      actionsList.push({
        type: ActionTypes.DELETE,
        icon: 'delete',
        message: messages.listItemActionDelete,
      });
    }

    return actionsList;
  }

  constructor(props) {
    super(props);
    this.state = {
      list: [],
    };
  }

  onClickItem = (type) => () => {
    const { onAction, plugin } = this.props;
    if (onAction) {
      onAction(type, plugin);
    }
  }

  render() {
    const { list } = this.state;

    if (!list.length) {
      return <div style={{ width: 34 }} />;
    }

    return (
      <MoreButtonWithPopper placement="bottom-end" hidepopperonclick>
        <Menu>
          <MenuList>
            {
              list.map((item) => (
                <MenuListItem key={item.type} onClick={this.onClickItem(item.type)}>
                  <MaterialIcon id={item.icon} />
                  <MenuListItemText>
                    {intl.formatMessage(item.message)}
                  </MenuListItemText>
                </MenuListItem>
              ))
            }
          </MenuList>
        </Menu>
      </MoreButtonWithPopper>
    );
  }
}

PluginsListItemActions.propTypes = {
  plugin: PropTypes.object,
  onAction: PropTypes.func,
};

export default PluginsListItemActions;
